import { global } from '@navinc/utils'

export const isTestEnv = () => ['test', 'local'].includes(global?.process?.env?.NODE_ENV)
